module.exports = __webpack_public_path__ + "static/media/BuiltSmartSlide05.c94fbb61.jpg";